export enum ModalDismissReasons {
  BACKDROP_CLICK,
  ESC
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
